export type ClipQuota = {
  limit: number | null;
  used: number;
  nextAvailableAt: string | null;
};

export const isClipLimitEnforced = (userEmail?: string): boolean => {
  if (process.env.REACT_APP_CLIP_LIMIT_ENFORCED === "true") return true;
  if (userEmail && userEmail.endsWith("@allstar.gg")) return true;
  return false;
};

export const isAtClipLimit = (clipQuota: ClipQuota | undefined): boolean => {
  if (!clipQuota || clipQuota.limit === null) return false;
  return clipQuota.used >= clipQuota.limit;
};
